import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { getSetting } from "../../../../hooks/service";

export const useGetCSLink = ({ options, userCurrency }) => {
  return useQuery(
    [queryKey.CS_LINK_APPLY],
    () =>
      getSetting({ userCurrency: userCurrency }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};
